<template>
  <router-view />
  <Notification :show="notificationStore.show" :message="notificationStore.message" :type="notificationStore.type"
    @close="notificationStore.hideNotification" />
  <FormFloatingActions />
</template>

<script setup lang="ts">
import Notification from './components/shared/Notification.vue';
import FormFloatingActions from './components/shared/FormFloatingActions.vue';
import { useNotificationStore } from './stores/notification';

const notificationStore = useNotificationStore();
</script>

<style>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}
</style>